import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { localize } from 'core/localization';
import Popover, { ArrowContainer } from 'react-tiny-popover';
import { HINT_FOR_SPOT_COMMENT, HINT_FOR_GENERAL_COMMENT } from 'constants/review';
import { HintWrapper, HintContainer, HintButton, HintElementsContainer } from './Hint.styled';

export class Hint extends PureComponent {
  state = {
    isExpanded: this.props.isExpanded
  };

  componentWillMount() {
    let { hintName } = this.props;
    if (hintName) {
      this.setState({
        isExpanded: !localStorage.getItem(hintName) || false
      });
    }
    this.showReviewHints(hintName);
  }

  componentDidUpdate(prevProps) {
    let { isExpanded, hintName } = this.props;
    if (isExpanded !== prevProps.isExpanded) {
      this.setState({
        isExpanded
      });
    }
    this.hintShowOnce(hintName);
  }

  hintShowOnce = hintName => {
    if (hintName) {
      localStorage.setItem(hintName, true);
      this.setState({
        isExpanded: !localStorage.getItem(hintName)
      });
    }
  };

  showReviewHints = hintName => {
    if (hintName === HINT_FOR_GENERAL_COMMENT) {
      this.setState({
        isExpanded: false
      });
      if (
        localStorage.getItem(HINT_FOR_SPOT_COMMENT) &&
        !localStorage.getItem(HINT_FOR_GENERAL_COMMENT)
      ) {
        this.setState({
          isExpanded: true
        });
      }
    }
  };

  closePopover = event => {
    event.preventDefault();
    let { isExpanded } = this.state;
    let { hintName } = this.props;
    this.setState({
      isExpanded: !isExpanded
    });

    this.hintShowOnce(hintName);
  };

  render() {
    let { isExpanded } = this.state;
    let { hintElements, children } = this.props;
    return (
      <Popover
        tabIndex="1"
        isOpen={isExpanded}
        padding={0}
        align={'start'}
        transitionDuration={0.15}
        containerStyle={{ zIndex: 10, margin: '-5px' }}
        onClickOutside={this.toggle}
        content={({ position, targetRect, popoverRect }) => (
          <ArrowContainer
            position={position}
            targetRect={targetRect}
            popoverRect={popoverRect}
            arrowColor={'#fff'}
            arrowSize={6}
            style={{
              padding: '6px',
              position: 'relative',
              animation: `${
                position.includes('top' || 'bottom') ? 'shakevertical' : 'shakehorizontal'
              } 1s infinite ease-in-out`
            }}
          >
            <HintWrapper>
              <HintContainer>
                <HintElementsContainer>{hintElements}</HintElementsContainer>
                <HintButton onClick={this.closePopover}>{localize('[got it]')}</HintButton>
              </HintContainer>
            </HintWrapper>
          </ArrowContainer>
        )}
      >
        {children}
      </Popover>
    );
  }
}

Hint.propTypes = {
  children: PropTypes.any,
  isExpanded: PropTypes.bool,
  hintElements: PropTypes.any.isRequired,
  hintName: PropTypes.string
};

Hint.defaultProps = {
  children: null,
  isExpanded: true,
  hintElements: null,
  hintName: ''
};

export default Hint;
